<template>
<div class="settings-modal">
  <h5 class="mt-2 pr-5">{{ 'settings.TITLE' | translate }}</h5>
  <p class="mt-4 pr-5">{{ 'settings.SUMMARY' | translate }}</p>
  <div class="row mt-4">
    <div class="col-lg-6">
      <p>{{ 'settings.VERSION_SUMMARY' | translate }}</p>
      <div class="position-relative">
        <table class="table table-sm table-striped">
          <caption class="accessibly-hidden">{{ 'settings.VERSION_TABLE_CAPTION' | translate }}</caption>
          <thead>
            <tr class="d-none">
              <th scope="col">{{ 'settings.VERSION_TABLE_HEADER_MODULE' | translate }}</th>
              <th scope="col" class="text-right">{{ 'settings.VERSION_TABLE_HEADER_VERSION' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ 'version.LABEL_WEB' | translate }}</td>
              <td class="text-right font-weight-semibold">v{{webpagesVersion}}</td>
            </tr>
            <template v-for="(version, module) in versions">
              <tr v-if="versionsToDisplay.includes(module)">
                <td>{{ 'version.LABEL_' + module | translate }}</td>
                <td class="text-right font-weight-semibold">v{{ version }}</td>
              </tr>
            </template>
          </tbody>
        </table>
        <div v-if="!versionsLoaded" class="versions-spinner-container">
          <div class="versions-spinner"><i class="fa fa-circle-o-notch fa-spin fa-lg fa-fw" aria-hidden="true"></i></div>
        </div>
      </div>
      <span v-if="errorLoadingVersions" class="text-danger">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        {{ 'msg.ERROR_GETTING_VERSIONS' | translate }}
      </span>
    </div>
    <div class="col-lg-6">
      <div class="form-group d-inline-block w-75">
        <label>{{ 'settings.DEFAULT_PAGE' | translate }}</label>
        <select v-model="selectedPage" class="form-control form-control-sm">
          <option v-for="(pageRoles, page) in pages"
                  v-if="isRoleBasedAccessAllowed(pageRoles)"
                  :value="page"
                  selected>
            {{ page | translate('nav') }}
          </option>
        </select>
      </div>
      <div class="form-group d-inline-block w-75">
        <label>{{ 'settings.SALES_CHANNELS' | translate }}</label>
        <select v-model="selectedChannel" class="form-control form-control-sm">
          <option value="ALL">{{ 'ALL' | translate }}</option>
          <option v-for="channel in channels" :value="channel" selected>
            {{ channel }}
          </option>
        </select>
      </div>
      <div v-if="showSpinner" class="spinner-container d-inline-block">
        <i class="fa fa-circle-o-notch fa-spin fa-lg fa-fw" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import KeycloakService from '../service/keycloak/KeycloakService';
import { PageRoles } from '../service/keycloak/PageRoles';
import RestService from '../service/RestService.js';
import UserSettingsService from '../service/UserSettingsService';

export default {
  name: 'VersionsAndSettings',
  data: function () {
    return {
      rest: this.initRestService(),
      pages: PageRoles,
      selectedPage: null,
      showSpinner: false,
      versionsToDisplay: ['MODEL', 'RULES', 'CASES', 'ADMIN', 'CHARTS'],
      versions: {},
      versionsLoaded: false,
      errorLoadingVersions: false,
      webpagesVersion: process.env.WEBPAGES_VERSION,
      channels: {},
      selectedChannel: null
    }
  },
  async beforeMount() {
    this.selectedPage = this.getStartingPage();
    this.channels = await UserSettingsService.getChannelList();
    this.selectedChannel = UserSettingsService.getUserChannel() || 'ALL';
    let response;
    response = await this.rest.getVersionFromCasesModule()
        .catch((err) => this.handleErrorWhenFetchingVersions(err));
    if (response) this.versions = {...this.versions, ...response.data};
    response = await this.rest.getVersionFromAdminModule()
        .catch((err) => this.handleErrorWhenFetchingVersions(err));
    if (response) this.versions = {...this.versions, ...response.data};
    response = await this.rest.getVersionFromChartsModule()
        .catch((err) => this.handleErrorWhenFetchingVersions(err));
    if (response) this.versions = {...this.versions, ...response.data};
    this.versionsLoaded = true;
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    handleErrorWhenFetchingVersions(error) {
      this.errorLoadingVersions = true;
      this.$log.error(error);
    },
    getStartingPage() {
      return UserSettingsService.getStartingPage();
    },
    setStartingPage() {
      this.showSpinner = true;
      UserSettingsService.saveUserStartingPage(this.selectedPage);
      setTimeout(() => { this.showSpinner = false; }, 300);
    },
    isRoleBasedAccessAllowed(roles) {
      return KeycloakService.isRoleBasedAccessAllowed(roles);
    },
    setSelectedChannel() {
      if (!this.selectedChannel || this.selectedChannel === 'ALL') {
        UserSettingsService.clearUserChannel();
      } else {
        UserSettingsService.saveUserChannel(this.selectedChannel);
      }
      setTimeout(() => { this.showSpinner = false; }, 300);
    }
  },
  watch: {
    selectedPage() {
      this.setStartingPage();
    },
    selectedChannel() {
      this.setSelectedChannel();
    }
  }
}
</script>

<style scoped>
  .settings-modal {
    font-size: 14px;
  }
  .spinner-container {
    margin-left: 10px;
    vertical-align: text-bottom;
  }
  .fa-spin {
    color: #0056a7;
  }
  .versions-spinner-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.3);
  }
  .versions-spinner {
    position: relative;
    top: 50%;
    text-align: center;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/VersionsAndSettings.vue